import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Box } from "@material-ui/core";
import A_Button from "../../../Atoms/Inputs/Buttons/A_Button";
import M_CheckList from "../../../Molecules/Common/Checklist/M_CheckList";
import O_Mail from "../IRC_Mail/O_Mail";
import { labelName } from "../../../../../Utils/config/config";

function O_CheckList(props) {
  const { data: primaryData } = props.currentPage;

  const handleBookIRC = () => {
    props.reload();
  };

  const getReload = () => {
    props.reload();
  };

  return (
    <>
      {props?.checkListData?.checklistData?.length > 0 && (
        <div>
          {!props.hideChecklistItems && (
            <M_CheckList
              config={props.content}
              data={props.checkListData.checklistData}
              type="preIRC"
              formParam={primaryData}
              {...props}
            />
          )}

          {!props.hideChecklistItems && (
            <Box
              bgcolor={"#fcf8e3"}
              color={"#fec85f"}
              width={"100%"}
              padding={"1rem"}
              marginY={"1rem"}
            >
              {props.content && props.content.ircMssg
                ? props.content.ircMssg
                : labelName.IRC_Mssg}
            </Box>
          )}

          <Box paddingTop={"2rem"} display={"flex"} justifyContent={"end"}>
            <A_Button
              label="Reschedule"
              color={"primary"}
              onClick={handleBookIRC}
            />
            {props?.checkListData?.isCompleted || props.hideChecklistItems ? (
              <O_Mail
                content={props.content}
                label={
                  props.content && props.content.ircMailButtonLabel
                    ? props.content.ircMailButtonLabel
                    : labelName.IRC_BUTTON
                }
                ircID={
                  props.checkListData &&
                  props.checkListData.checklistData &&
                  Array.isArray(props.checkListData.checklistData) &&
                  props.checkListData.checklistData[0] &&
                  props.checkListData.checklistData[0].dealChecklist &&
                  props.checkListData.checklistData[0].dealChecklist.dealIrcId
                }
                formData={{}}
                reload={getReload}
              />
            ) : (
              <A_Button
                label={
                  props.content && props.content.ircMailButtonLabel
                    ? props.content.ircMailButtonLabel
                    : labelName.IRC_BUTTON
                }
                disabled={true}
                color={"primary"}
              />
            )}
          </Box>
        </div>
      )}
    </>
  );
}

O_CheckList.propTypes = {
  content: PropTypes.shape({
    ircMssg: PropTypes.string,
    ircMailButtonLabel: PropTypes.string,
  }),
  checkListData: PropTypes.shape({
    isCompleted: PropTypes.bool,
    checklistData: PropTypes.arrayOf(
      PropTypes.shape({
        dealChecklist: PropTypes.shape({
          dealIrcId: PropTypes.string,
        }),
      })
    ),
  }),
  hideChecklistItems: PropTypes.bool,
  reload: PropTypes.func,
  currentPage: PropTypes.shape({
    data: PropTypes.object,
  }),
};

function mapStateToProps(state) {
  return {
    currentPage: state.currentPage,
  };
}

export default connect(mapStateToProps)(O_CheckList);
